

export const veoFAQ = {
    title: '常見問題',
    subtitle: '了解影片生成、關鍵幀、參考圖與原生音訊功能。',
    items: [
      { num: '01', q: '什麼是 AI 影片生成？有哪些新功能？', a: '支援關鍵幀、多張參考圖、原生音訊、延長時長、角色一致性等功能。' },
      { num: '02', q: '關鍵幀如何運作？', a: '上傳起始/結尾幀，系統生成平滑過渡，精準掌控影片開頭與結尾。' },
      { num: '03', q: '多張參考圖是什麼？', a: '以多圖引導角色、打光與色調，維持全片一致的視覺風格。' },
      { num: '04', q: '是否支援原生音訊？', a: '支援原生音訊。自動生成對白、環境音與動作同步音效，與畫面一致。' },
      { num: '05', q: '角色一致性如何做到？', a: '提供角色參考圖，系統在多場景維持角色外觀與身份一致。' },
      { num: '06', q: 'AI 影片生成有何不同？', a: '關鍵幀、多圖、延時、原生音訊、角色一致、真實運動、1080P。' },
      { num: '07', q: '商業使用？', a: '可以。輸出可用於商業專案，音訊與畫質達到專業標準。' },
      { num: '08', q: '費用如何計算？', a: '採積分制，HD 升級可選；進階功能包含於生成成本。' },
      { num: '09', q: '有哪些創作控制？', a: '關鍵幀、參考圖、角色一致、延時、音訊、運動控制，達到電影級精準。' },
      { num: '10', q: '新手適合嗎？', a: '適合。介面直覺，上傳圖片或輸入文字即可開始。' },
      { num: '11', q: '生成長度？', a: '起始 8 秒；使用延長功能可創作更長影片並維持品質。' },
      { num: '12', q: '品質提升建議？', a: '詳述提示、使用關鍵幀、多圖、角色一致、品質模式、升級 1080P。' },
      { num: '13', q: '為何失敗？', a: '多為內容政策或輸入不符。請遵循指引並確保圖片規格正確。' },
      { num: '14', q: '如何製作長片？', a: '使用延長功能或以一致的多段剪輯拼接，達到流暢長內容。' }
    ],
    more: '還有關於影片生成的問題？',
    contact: '聯絡支援團隊 →'
  };
